export default [
  // 特殊兑换码需求（（1）发放手机号必须与兑换手机号一致（2）同步兑换码（3）需要专属兑换链接，在其他兑换链接不可被兑换）
  {
    path: '/SpecialKwai',
    name: 'SpecialKwai',
    meta: { title: '快手本地生活' },
    component: () => import('@/views/SpecialKwai')
  },
  {
    path: '/SpecialKwaiList',
    name: 'SpecialKwaiList',
    meta: { title: '快手本地生活' },
    component: () => import('@/views/SpecialKwai/list')
  },
  {
    path: '/SpecialKwaiCrowded',
    name: 'SpecialKwaiCrowded',
    meta: { title: '快手本地生活' },
    component: () => import('@/views/SpecialKwai/crowded')
  },
  {
    path: '/SpecialKwaiOutStock',
    name: 'SpecialKwaiOutStock',
    meta: { title: '快手本地生活' },
    component: () => import('@/views/SpecialKwai/outStock')
  }
]
